import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ListsActionsLazyEffects } from './+state/lists-actions.lazy.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ListsActionsLazyEffects])]
})
export class ListsActionsLazyModule {}
